import { useContext, useCallback } from 'react';
import { useAtom } from 'jotai';
import { completedToursAtom } from '../../../atoms/tour-atoms';
import { TourContext } from './TourProvider';
import type { TourConfig } from './tour.types';

interface UseTourOptions {
  onComplete?: () => void;
}

interface UseTourReturn {
  startTour: () => void;
  isCompleted: boolean;
  resetTour: () => void;
}

export function useTour(config: TourConfig, options?: UseTourOptions): UseTourReturn {
  const { startTour: contextStartTour } = useContext(TourContext);
  const [completedTours, setCompletedTours] = useAtom(completedToursAtom);

  const isCompleted = !!completedTours[config.id];

  const startTour = useCallback(() => {
    contextStartTour(config, options?.onComplete);
  }, [contextStartTour, config, options?.onComplete]);

  const resetTour = useCallback(() => {
    setCompletedTours((prev) => {
      const next = { ...prev };
      delete next[config.id];
      return next;
    });
  }, [config.id, setCompletedTours]);

  return { startTour, isCompleted, resetTour };
}
